import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map, take, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { saveAs } from 'file-saver';
import * as i1 from '@angular/common/http';
import moment from 'moment';
import { environment } from 'environment-configurations';
import * as i2 from '@angular/common';
import * as i3 from 'primeng/table';
import * as i4 from 'primeng/api';
import * as i5 from 'primeng/button';
import * as i6 from 'primeng/tooltip';
import { PrimengLibraryModule } from 'primeng-library';
import { PdfViewerModule } from 'ng2-pdf-viewer';

class LibViewTimesheetService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getTimesheetDetails(Id) {
        return this.http.get(`/vd/formBuilder/employee/project/timesheet/${Id}/details`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    downloadDocuments(path, fileName) {
        this.http.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(file => {
            const blob = new Blob([file], { type: 'text/csv' });
            saveAs(blob, fileName);
        });
    }
    downloadPDFDocument(path, fileName) {
        this.http.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(file => {
            const blob = new Blob([file], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
    getProjects(startDate) {
        return this.http.get(`/vd/formBuilder/timesheet/employee/project/timesheet?date=${startDate}`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getProjectList(groupName) {
        return this.http.get(`/vd/dataSource/${groupName}/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
LibViewTimesheetService.ɵfac = function LibViewTimesheetService_Factory(t) { return new (t || LibViewTimesheetService)(i0.ɵɵinject(i1.HttpClient)); };
LibViewTimesheetService.ɵprov = i0.ɵɵdefineInjectable({ token: LibViewTimesheetService, factory: LibViewTimesheetService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibViewTimesheetService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function LibViewTimesheetComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Reason : ", (ctx_r0.timesheetDetails[0] == null ? null : ctx_r0.timesheetDetails[0].reason) ? ctx_r0.timesheetDetails[0] == null ? null : ctx_r0.timesheetDetails[0].reason : "--", "");
} }
function LibViewTimesheetComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "th", 15);
    i0.ɵɵelementStart(2, "th", 16);
    i0.ɵɵtext(3, "Emp.ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th", 17);
    i0.ɵɵtext(5, "Employee Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 16);
    i0.ɵɵtext(7, "Total");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th", 18);
    i0.ɵɵtext(9, "Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0, a1) { return { "rejected": a0, "approved": a1 }; };
function LibViewTimesheetComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 19);
    i0.ɵɵelementStart(1, "td", 15);
    i0.ɵɵelement(2, "button", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td", 16);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 17);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 16);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 21);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const timesheetDetails_r5 = ctx.$implicit;
    const expanded_r6 = ctx.expanded;
    i0.ɵɵproperty("pSelectableRow", timesheetDetails_r5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pRowToggler", timesheetDetails_r5)("icon", expanded_r6 ? "pi pi-chevron-down" : "pi pi-chevron-right");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((timesheetDetails_r5 == null ? null : timesheetDetails_r5.employeeId) ? timesheetDetails_r5 == null ? null : timesheetDetails_r5.employeeId : "--");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", (timesheetDetails_r5 == null ? null : timesheetDetails_r5.employeeName) ? timesheetDetails_r5 == null ? null : timesheetDetails_r5.employeeName : "--", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((timesheetDetails_r5 == null ? null : timesheetDetails_r5.totalHours) ? timesheetDetails_r5 == null ? null : timesheetDetails_r5.totalHours : "--");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c0, (timesheetDetails_r5 == null ? null : timesheetDetails_r5.status == null ? null : timesheetDetails_r5.status.name) == "Rejected", (timesheetDetails_r5 == null ? null : timesheetDetails_r5.status == null ? null : timesheetDetails_r5.status.name) == "Submitted"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (timesheetDetails_r5 == null ? null : timesheetDetails_r5.status == null ? null : timesheetDetails_r5.status.name) ? timesheetDetails_r5 == null ? null : timesheetDetails_r5.status == null ? null : timesheetDetails_r5.status.name : "--", "");
} }
function LibViewTimesheetComponent_ng_template_14_div_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th");
    i0.ɵɵtext(5, "Project");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th");
    i0.ɵɵtext(7, "Activity");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9, "Total Hours");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, item_r9.date, "fullDate"));
} }
function LibViewTimesheetComponent_ng_template_14_div_3_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "td");
    i0.ɵɵelementStart(2, "td");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r16 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(rowData_r16 == null ? null : rowData_r16.projectName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(rowData_r16 == null ? null : rowData_r16.activity);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(rowData_r16 == null ? null : rowData_r16.time);
} }
function LibViewTimesheetComponent_ng_template_14_div_3_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "td", 27);
    i0.ɵɵelementStart(2, "td");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("class", item_r9.dailyTotal < 8 ? "colored" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r9.dailyTotal, " Hours");
} }
function LibViewTimesheetComponent_ng_template_14_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "p-table", 25);
    i0.ɵɵtemplate(2, LibViewTimesheetComponent_ng_template_14_div_3_ng_template_2_Template, 10, 4, "ng-template", 9);
    i0.ɵɵtemplate(3, LibViewTimesheetComponent_ng_template_14_div_3_ng_template_3_Template, 8, 3, "ng-template", 10);
    i0.ɵɵtemplate(4, LibViewTimesheetComponent_ng_template_14_div_3_ng_template_4_Template, 4, 2, "ng-template", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", item_r9.details);
} }
function LibViewTimesheetComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 22);
    i0.ɵɵelementStart(2, "div", 6);
    i0.ɵɵtemplate(3, LibViewTimesheetComponent_ng_template_14_div_3_Template, 5, 1, "div", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r3.timesheetDetails[0].projectTimesheetDetails);
} }
function LibViewTimesheetComponent_div_15_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵelementStart(2, "div", 32);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 33);
    i0.ɵɵelementStart(5, "button", 34);
    i0.ɵɵlistener("click", function LibViewTimesheetComponent_div_15_div_4_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r21); const data_r19 = ctx.$implicit; const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.viewDoc(data_r19); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 33);
    i0.ɵɵelementStart(7, "button", 35);
    i0.ɵɵlistener("click", function LibViewTimesheetComponent_div_15_div_4_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r21); const data_r19 = ctx.$implicit; const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.DownloadDoc(data_r19); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r19 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", data_r19.fileName, " ");
} }
function LibViewTimesheetComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "h5", 4);
    i0.ɵɵtext(3, "Uploaded Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, LibViewTimesheetComponent_div_15_div_4_Template, 8, 1, "div", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r4.getFileName);
} }
const _c1 = function () { return { "min-width": "70rem" }; };
class LibViewTimesheetComponent {
    constructor(viewTimesheetService) {
        this.viewTimesheetService = viewTimesheetService;
        this.observableSubscription$ = new Subject();
        this.timesheetDetails = [];
        this.timesheetArrObj = [];
        this.displayBasic = false;
        this.showLoader = false;
        this.selecteddaterange = [];
        this.selecteddatelist = [];
        this.months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        this.weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        this.projectList = [];
    }
    ngOnInit() {
        this.getTimesheetDetails();
    }
    viewDoc(data) {
        var path;
        if (data.fileLocation.includes("var/www/")) {
            path = environment.appUrl + data.fileLocation.replace('var/www/', '');
        }
        if (data.fileLocation.includes("/var/imagility/uploads/")) {
            path = environment.docs + data.fileLocation.replace('/var/imagility/uploads/', '');
        }
        window.open(`${path}`, "_blank");
    }
    /* viewDoc(data) {
      const path = environment.docs + data.fileLocation.replace('/var/imagility/uploads/', '');
      window.open(`${path}`, "_blank");
    } */
    DownloadDoc(data) {
        var path;
        if (data.fileLocation.includes("/var/imagility/uploads/")) {
            path = environment.docs + data.fileLocation.replace('/var/imagility/uploads/', '');
            this.viewTimesheetService.downloadDocuments(path, data.fileName);
        }
        if (data.fileLocation.includes("var/www/")) {
            path = environment.appUrl + data.fileLocation.replace('var/www/', '');
            this.viewTimesheetService.downloadPDFDocument(path, data.fileName);
        }
        //const path = environment.docs + data.fileLocation.replace('/var/imagility/uploads/', '');
        // if(data.fileFormat == 'pdf'){
        //}
        //else{
        // window.open(`${path}`, "_blank");
        //}
    }
    getProjects(fromDateString) {
        this.viewTimesheetService
            .getProjectList('FB_PROJECTS_BY_COMPANY').pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.projectList = (response === null || response === void 0 ? void 0 : response.data) || [];
            this.timesheetDetails[0].projectTimesheetDetails.forEach(item => {
                if (item.details.length > 0) {
                    item.details.forEach(obj => {
                        obj.projectName = this.projectList.find(el => el.id == obj.projectId).name;
                    });
                }
                item.color = (item.dailyTotal < 8) ? 'red' : '#495057';
            });
        });
    }
    getTimesheetDetails() {
        this.id = 'idToGetDetails' in sessionStorage ? parseInt(sessionStorage.getItem('idToGetDetails')) : null;
        if (this.id) {
            this.viewTimesheetService.getTimesheetDetails(this.id).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                var _a, _b;
                this.timesheetDetails.push(response.data);
                this.timesheetArrObj = ((_a = this.timesheetDetails[0]) === null || _a === void 0 ? void 0 : _a.projectTimesheetDetails) || [];
                this.weeklyTotal = this.timesheetDetails[0].totalHours || 0;
                let fromDate = moment.utc(this.timesheetDetails[0].fromDate).format("MMMM DD YYYY").toString();
                let toDate = moment.utc(this.timesheetDetails[0].toDate).format("MMMM DD YYYY").toString();
                this.displayDateRange = fromDate + " - " + toDate;
                this.getFileName = (_b = this.timesheetDetails[0]) === null || _b === void 0 ? void 0 : _b.uploadFiles;
                //this.getProjects(moment.utc(this.timesheetDetails[0].fromDate).format("MM/DD/YYYY"));
            });
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
LibViewTimesheetComponent.ɵfac = function LibViewTimesheetComponent_Factory(t) { return new (t || LibViewTimesheetComponent)(i0.ɵɵdirectiveInject(LibViewTimesheetService)); };
LibViewTimesheetComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibViewTimesheetComponent, selectors: [["lib-view-timesheet"]], decls: 16, vars: 8, consts: [[1, "container-fluid", "view_project_timesheet", "p-0", "mt-2", "mb-2", "pb-3"], [1, "row", "date_range"], [1, "col-6"], [1, "col-6", "text-right"], [1, "w-600"], ["class", "row pl-3", 4, "ngIf"], [1, "row"], [1, "col-12", "p-0"], ["dataKey", "name", "rowExpandMode", "single", 1, "parent_table", 3, "value", "scrollable", "tableStyle"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "rowexpansion"], ["class", "row p-2", 4, "ngIf"], [1, "row", "pl-3"], [1, "col-12", "wrap"], [2, "width", "3rem"], [2, "width", "80px"], [2, "width", "120px"], [2, "width", "95px"], [3, "pSelectableRow"], ["type", "button", "pButton", "", "pRipple", "", 1, "p-button-text", "p-button-rounded", "p-button-plain", 3, "pRowToggler", "icon"], [2, "width", "95px", 3, "ngClass"], ["colspan", "5"], ["class", "col-12", 4, "ngFor", "ngForOf"], [1, "col-12"], ["styleClass", "p-datatable-striped", 3, "value"], ["pTemplate", "footer"], ["colspan", "3"], [1, "row", "p-2"], [1, "col-12", "pl-0"], ["class", "col-12 p-0", 4, "ngFor", "ngForOf"], [1, "row", "doc_bg"], [1, "col-10", "p-2", "doc_bg"], [1, "col-1"], ["pButton", "", "type", "button", "icon", "pi pi-eye", "pTooltip", "View", 1, "p-button-text", "p-button-rounded", 3, "click"], ["pButton", "", "type", "button", "icon", "pi pi-download", "pTooltip", "Download", 1, "p-button-text", "p-button-rounded", 3, "click"]], template: function LibViewTimesheetComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h5");
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "h5", 4);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, LibViewTimesheetComponent_div_8_Template, 4, 1, "div", 5);
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelementStart(10, "div", 7);
        i0.ɵɵelementStart(11, "p-table", 8);
        i0.ɵɵtemplate(12, LibViewTimesheetComponent_ng_template_12_Template, 10, 0, "ng-template", 9);
        i0.ɵɵtemplate(13, LibViewTimesheetComponent_ng_template_13_Template, 11, 11, "ng-template", 10);
        i0.ɵɵtemplate(14, LibViewTimesheetComponent_ng_template_14_Template, 4, 1, "ng-template", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, LibViewTimesheetComponent_div_15_Template, 5, 1, "div", 12);
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.displayDateRange);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("Total Hours: ", ctx.weeklyTotal, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.timesheetDetails[0] == null ? null : ctx.timesheetDetails[0].reason);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("value", ctx.timesheetDetails)("scrollable", true)("tableStyle", i0.ɵɵpureFunction0(7, _c1));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.getFileName);
    } }, directives: [i2.NgIf, i3.Table, i4.PrimeTemplate, i3.SelectableRow, i5.ButtonDirective, i3.RowToggler, i2.NgClass, i2.NgForOf, i6.Tooltip], pipes: [i2.DatePipe], styles: [".doc_bg[_ngcontent-%COMP%]{background:#edf4fb}.wrap[_ngcontent-%COMP%]{word-wrap:break-word}.colored[_ngcontent-%COMP%]{color:red!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibViewTimesheetComponent, [{
        type: Component,
        args: [{
                selector: "lib-view-timesheet",
                templateUrl: "lib-view-timesheet.component.html",
                styleUrls: ["lib-view-timesheet.component.scss"],
            }]
    }], function () { return [{ type: LibViewTimesheetService }]; }, null); })();

class LibViewTimesheetModule {
}
LibViewTimesheetModule.ɵfac = function LibViewTimesheetModule_Factory(t) { return new (t || LibViewTimesheetModule)(); };
LibViewTimesheetModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibViewTimesheetModule });
LibViewTimesheetModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            PdfViewerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibViewTimesheetModule, { declarations: [LibViewTimesheetComponent], imports: [PrimengLibraryModule,
        PdfViewerModule], exports: [LibViewTimesheetComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibViewTimesheetModule, [{
        type: NgModule,
        args: [{
                declarations: [LibViewTimesheetComponent],
                imports: [
                    PrimengLibraryModule,
                    PdfViewerModule
                ],
                exports: [LibViewTimesheetComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-view-timesheet
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibViewTimesheetComponent, LibViewTimesheetModule, LibViewTimesheetService };
//# sourceMappingURL=lib-view-timesheet.js.map
